<template>
  <el-dialog
    title="修改SN号"
    :visible.sync="show"
    width="600px"
  >
    <div class="remark__content">
      <el-row>
        <el-col :span="4">卡号：</el-col>
        <el-col :span="18">
          <el-input v-model="formData.sn" />
        </el-col>
        <el-col :span="4">imei号：</el-col>
        <el-col :span="18">
          <el-input v-model="formData.imei" />
        </el-col>
        <el-col :span="4">sim卡号：</el-col>
        <el-col :span="18">
          <el-input v-model="formData.simCard" />
        </el-col>
        <el-col :span="4">设备类型：</el-col>
        <el-col :span="18">
          <el-input v-model="formData.equipmentType" />
        </el-col>
        <el-col :span="4">iccid：</el-col>
        <el-col :span="18">
          <el-input v-model="formData.iccid" />
        </el-col>
      </el-row>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="type" @click="show = false">取 消</el-button>
      <el-button size="type" type="primary" @click="onAddRemark">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name:"snForm",
  props:{
    visible:{
      type:Boolean,
      default:false
    },
    info:{
      type:Object,
      default:() => {}
    }
  },
  data(){
    return {
      show:false,
      formData:{
        id:'',
        sn:'',
        imei:'',
        simCard:'',
        equipmentType:'',
        iccid:'',
      }
    }
  },
  watch:{
    visible:{
      handler(val){
        this.show = val;
        this.remarks = '';
        if(val){
          const { createTime , updateTime , userId , ...params } = this.info;
          this.formData = params;
        }
      }
    },
    show:{
      handler(val){
        !val && this.$emit('update:visible',false);
      }
    }
  },
  methods:{
    // 备注
    async onAddRemark(){
      try{
        const { 
          sn,
          imei,
          simCard,
          equipmentType,
          iccid,
         } = this.formData;
        if(!sn) throw { msg:'请填写sn号' };
        if(!imei) throw { msg:'请填写imei号' };
        //if(!simCard) throw { msg:'请填写sim卡号' };
        if(!equipmentType) throw { msg:'请填写设备类型' };
        if(!iccid) throw { msg:'请填写iccid' };

        const { msg , code } = await this.$API.updateSnInfo(this.formData);
        if(code === 200) throw { msg };
        this.$message({
          type:'success',
          message:'备注成功'
        });
        this.$emit('update:visible',false);
        this.$emit('onSuccess');
      }catch({ msg }){
        this.$message({
          type:'warning',
          message:msg
        });
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.remark__content{
  ::v-deep .el-col{
    margin-bottom: 10px;
    line-height: 34px;
  }
}
</style>
